module.exports = __webpack_public_path__ + "static/media/pds-icon.5af3b2c5.svg";